import "./TableHeaders.css";

import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { createNewLsUserSettings } from "core/local_storage_utils";
import { getStorageUserSettings, userAdvActions } from "slices/user_adv";

import { useResizeColumn } from "./ColumnResizer/useResizeColumn";
import { HeaderColumn } from "./HeaderColumn";

export default function TableHeaders(props) {
	const dispatch = useDispatch();
	const userSettings = useSelector(getStorageUserSettings);
	const pageKey = props.options?.localStoragePageKey;
	const columnsSettings = userSettings?.[pageKey]?.columnsSettings;

	const [isMouseDown, setIsMouseDown] = useState(false);
	const [isResizing, setIsResizing] = useState(true);
	const [resizeLeft, setResizeLeft] = useState(0);

	const resizeParams = useRef({
		startX: 0,
		currentX: 0,
		clmName: "",
		cursorStyle: "pointer",
	});

	const saveColumnsSettings = (newColumnsSettings) => {
		if (!pageKey) return;

		const newUserSettings = createNewLsUserSettings({
			currentSettings: userSettings,
			pageName: pageKey,
			key: "columnsSettings",
			value: newColumnsSettings,
		});

		dispatch(userAdvActions.setUserSettings(newUserSettings));
	};

	const thRef = useRef([]);

	useEffect(() => {
		thRef.current = thRef.current.slice(0, props.columns.length);
	}, [props.columns.length]);

	const { mouseDownHandler } = useResizeColumn({ resizableElems: thRef.current, minWidth: 50, columnsSettings, saveColumnsSettings });

	const columnsDom = [];
	const columnsDomChilds = [];

	let clmIndex = 0;

	const preventHandle = (e) => {};

	for (let clm of props.columns) {
		if (clm.isVisibleOnHeader === false) continue;
		const clmWidth = clm.width;
		const minWidth = clm.minWidth;
		const customStyle = clm.headCustomStyle == null ? {} : clm.headCustomStyle;
		let columnDom = <></>;
		if (clm.hasOwnProperty("headerCellJsx")) {
			columnDom = clm.headerCellJsx({ clmObj: clm });
		} else {
			columnDom = (
				<HeaderColumn
					key={clm.name}
					ref={thRef}
					clm={clm}
					isResizing={isResizing}
					clmIndex={clmIndex}
					resizeLeft={resizeLeft}
					preventHandle={preventHandle}
					tableProps={props}
					storageClmSettings={columnsSettings?.[clm.name]}
					mouseDownHandler={mouseDownHandler(clmIndex)}
				/>
			);
		}

		columnsDom.push(columnDom);

		if (clm.children != null) {
			for (let clmChild of clm.children) {
				const columnDomChild = (
					<th
						key={clmChild.name}
						style={{
							textAlign: clmChild.headHorAlign,
							height: clmChild.headHeight,
							width: clmWidth,
							minWidth: minWidth,
							customStyle: customStyle,
						}}
						rowSpan={clmChild.rowSpan}
						colSpan={clmChild.colSpan}
						className="TableHeadCell"
					>
						<div
							className="TableHeadCellContent"
							style={{
								justifyContent: clmChild.headHorAlign,
								marginLeft: clmChild.marginLeft,
							}}
						>
							<div className="TableHeadCellTitle">{clmChild.title}</div>
						</div>
					</th>
				);
				columnsDomChilds.push(columnDomChild);
			}
		}

		clmIndex += 1;
	}

	useEffect(() => {
		if (!props.options?.resizableColumns) return;
		const handleMouseUp = (e) => {
			if (!e.target?.attributes?.clm?.value) {
				setIsMouseDown(false);
				setIsResizing(false);
			}
		};
		document.addEventListener("mouseup", handleMouseUp);
		return () => document.removeEventListener("mouseup", handleMouseUp);
	}, [props.options?.resizableColumns]);

	const handleMouseDown = (e) => {
		if (props.options?.resizableColumns !== true) return;
		resizeParams.current.clmName = e.target?.attributes?.clm?.value;
		if (resizeParams.current.clmName == null) return;
		setIsMouseDown(true);
		resizeParams.current.startX = e.clientX;
		resizeParams.current.cursorStyle = "col-resize";
	};

	const handleMouseUp = (e) => {
		if (props.options?.resizableColumns !== true) return;
		if (!isMouseDown) return;
		setIsMouseDown(false);
		resizeParams.current.cursorStyle = "pointer";
		const diff = resizeParams.current.currentX - resizeParams.current.startX;
		if (props.func.setParamUserSettings) {
			if (!props.options.userSettings?.[resizeParams.current.clmName]) return;
			const nextSetting = { ...props.options.userSettings?.[resizeParams.current.clmName] };
			nextSetting.width += diff;
			if (nextSetting.width < 40) nextSetting.width = 40;
			console.log(resizeParams.current.clmName, nextSetting.width);
			props.func.setParamUserSettings({ param: props.options.columnsSettingsName, key: resizeParams.current.clmName, value: nextSetting });

			if (props.func.saveUserSettings) props.func.saveUserSettings();
		}
		setIsResizing(false);
	};

	const handleMove = (e) => {
		if (props.options?.resizableColumns !== true) return;
		if (!isMouseDown) return;
		e.preventDefault();
		setIsResizing(true);
		resizeParams.current.currentX = e.clientX;
		setResizeLeft(e.clientX);
	};

	return (
		<thead
			className="TableHead"
			onMouseDown={handleMouseDown}
			onMouseUp={handleMouseUp}
			onMouseMove={handleMove}
			style={{ cursor: resizeParams.current.cursorStyle }}
		>
			<tr
				className="TableHeadRow"
				onMouseDown={preventHandle}
				onMouseUp={preventHandle}
				onMouseMove={preventHandle}
				style={{ cursor: resizeParams.current.cursorStyle }}
			>
				{columnsDom}
			</tr>
			{columnsDomChilds.length ? <tr className="TableHeadRow">{columnsDomChilds}</tr> : <></>}
		</thead>
	);
}
